import React, { useState, useEffect } from 'react';
import api from '../../../api';
import { useParams } from 'react-router-dom';

const LatestNewsSection = () => {
  const { miniSlug, slug } = useParams();
  const [newsData, setNewsData] = useState({
    title: 'Latest News',
    logo: '/storage/default-logo.png',
    items: [],
    loading: true
  });
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewsData = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/${miniSlug}/${slug}/news`);
        const data = response.data;

        setNewsData({
          title: data.title || 'Latest News',
          logo: data.logo || '/storage/default-logo.png',
          items: data.items || [],
          loading: false
        });
      } catch (error) {
        console.error('Error fetching news data:', error);
        setError(true);
        setNewsData(null);
      }
    };

    fetchNewsData();
  }, [miniSlug, slug]);

  if (error) return null;

  if (newsData.loading || newsData.items.length === 0) return null;

  return (
    <section className="latest_news_section py-3">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Logo Section */}
          <div className="col-md-2 col-5 p-0 p-md-auto">
            {newsData.logo && (
              <img
                src={`${process.env.REACT_APP_API_URL}/public/${newsData.logo}`}
                alt="College logo"
                className="img-fluid"
              />
            )}
          </div>

          {/* Scrolling News Section */}
          <div className="col-md-10 col-7 p-0 p-md-auto">
            <div className="trending-carousel-container d-flex align-items-center flex-column flex-md-row p-0 p-md-auto">
              
              {/* Mobile label */}
              <div className="trending-label me-3 d-block d-md-none">{newsData.title}</div>

              {/* Marquee */}
              <marquee
                behavior="scroll"
                direction="left"
                scrollAmount="6"
                onMouseOver={(e) => e.currentTarget.stop()}
                onMouseOut={(e) => e.currentTarget.start()}
                style={{ width: '100%' }}
              >
                {newsData.items.map((item, index) => {
                  const isPDF = item.type === 'pdf';
                  const href = isPDF
                    ? `${process.env.REACT_APP_API_URL}/public/${item.link}`
                    : item.link;

                  return (
                    <span className="me-5" key={index}>
                      <a
                        href={href}
                        target={item.target || '_blank'}
                        rel="noopener noreferrer"
                      >
                        {item.text}
                      </a>
                    </span>
                  );
                })}
              </marquee>

              {/* Desktop label */}
              <div className="trending-label me-3 d-none d-md-block">{newsData.title}</div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default LatestNewsSection;